

// import React, {
//   useEffect,
//   useState
// } from "react";

// import axios from "axios";

// import { API } from "../components/config";

// import "../style/ProfesorSimulacros.css";

// export default function ProfesorSimulacros() {

//   const token =
//     localStorage.getItem("token");

//   const headers = {
//     Authorization: `Bearer ${token}`
//   };

//   /* =====================================================
//      STATES
//   ===================================================== */

//   const [asignaciones,
//     setAsignaciones] = useState([]);

//   const [preguntas,
//     setPreguntas] = useState({});

//   const [mostrarFormulario,
//     setMostrarFormulario] = useState(null);

//   const [loadingPregunta,
//     setLoadingPregunta] = useState(false);

//   const [loadingFinalizar,
//     setLoadingFinalizar] = useState(null);

//   const [imagenPreview,
//     setImagenPreview] = useState(null);

//   const letras = [
//     "A",
//     "B",
//     "C",
//     "D",
//     "E",
//     "F",
//     "G",
//     "H"
//   ];

//   /* =====================================================
//      OPCIONES VACÍAS
//   ===================================================== */

//   const crearOpcionesVacias =
//     () => ([
//       {
//         texto: "",
//         es_correcta: false
//       },
//       {
//         texto: "",
//         es_correcta: false
//       },
//       {
//         texto: "",
//         es_correcta: false
//       },
//       {
//         texto: "",
//         es_correcta: false
//       }
//     ]);

//   /* =====================================================
//      FORM PREGUNTA
//   ===================================================== */

//   const [formPregunta,
//     setFormPregunta] = useState({

//       simulacro_id: "",
//       materia_simulacro_id: "",

//       enunciado: "",

//       tipo: "opcion_multiple",

//       explicacion: "",

//       imagen: null,

//       opciones:
//         crearOpcionesVacias()
//     });

//   /* =====================================================
//      FETCH ASIGNACIONES
//   ===================================================== */

//   const fetchAsignaciones =
//     async () => {

//       try {

//         const res =
//           await axios.get(
//             `${API}/simulacros/profesor/asignaciones`,
//             { headers }
//           );

//         setAsignaciones(
//           res.data.asignaciones || []
//         );

//       } catch (err) {

//         console.error(
//           "❌ Error asignaciones:",
//           err
//         );
//       }
//     };

//   /* =====================================================
//      FETCH PREGUNTAS
//   ===================================================== */

//   const fetchPreguntas =
//     async (simulacro_id) => {

//       try {

//         const res =
//           await axios.get(
//             `${API}/simulacros/profesor/preguntas/${simulacro_id}`,
//             { headers }
//           );

//         setPreguntas(prev => ({
//           ...prev,

//           [simulacro_id]:
//             res.data.preguntas || []
//         }));

//       } catch (err) {

//         console.error(
//           "❌ Error preguntas:",
//           err
//         );
//       }
//     };

//   /* =====================================================
//      INIT
//   ===================================================== */

//   useEffect(() => {

//     fetchAsignaciones();

//   }, []);

//   /* =====================================================
//      ABRIR FORM
//   ===================================================== */

//   const abrirFormulario =
//     (a) => {

//       setMostrarFormulario(a.id);

//       setImagenPreview(null);

//       setFormPregunta({

//         simulacro_id:
//           Number(a.simulacro_id),

//         materia_simulacro_id:
//           Number(a.materia_simulacro_id),

//         enunciado: "",

//         tipo: "opcion_multiple",

//         explicacion: "",

//         imagen: null,

//         opciones:
//           crearOpcionesVacias()
//       });

//       fetchPreguntas(
//         a.simulacro_id
//       );
//     };

//   /* =====================================================
//      FINALIZAR
//   ===================================================== */

//   const finalizarAsignacion =
//     async (a) => {

//       try {

//         const confirmar =
//           window.confirm(
//             "¿Desea finalizar esta asignación?"
//           );

//         if (!confirmar) return;

//         setLoadingFinalizar(
//           a.id
//         );

//         await axios.post(
//           `${API}/simulacros/profesor/finalizar`,
//           {

//             simulacro_id:
//               Number(a.simulacro_id),

//             materia_simulacro_id:
//               Number(a.materia_simulacro_id)

//           },
//           { headers }
//         );

//         await fetchAsignaciones();

//         alert(
//           "✅ Asignación finalizada"
//         );

//       } catch (err) {

//         console.error(err);

//         alert(
//           err?.response?.data?.message ||
//           "Error finalizando"
//         );

//       } finally {

//         setLoadingFinalizar(
//           null
//         );
//       }
//     };

//   /* =====================================================
//      OPCIONES
//   ===================================================== */

//   const handleOpcionTexto =
//     (index, value) => {

//       setFormPregunta(prev => {

//         const nuevas =
//           [...prev.opciones];

//         nuevas[index].texto =
//           value;

//         return {
//           ...prev,
//           opciones: nuevas
//         };
//       });
//     };

//   const seleccionarCorrecta =
//     (index) => {

//       const nuevas =
//         formPregunta.opciones.map(
//           (o, i) => ({
//             ...o,
//             es_correcta:
//               i === index
//           })
//         );

//       setFormPregunta(prev => ({
//         ...prev,
//         opciones: nuevas
//       }));
//     };

//   const agregarOpcion =
//     () => {

//       setFormPregunta(prev => ({

//         ...prev,

//         opciones: [
//           ...prev.opciones,
//           {
//             texto: "",
//             es_correcta: false
//           }
//         ]
//       }));
//     };

//   const eliminarOpcionFormulario =
//     (index) => {

//       if (
//         formPregunta.opciones
//           .length <= 2
//       ) {

//         return alert(
//           "Debe existir mínimo 2 opciones"
//         );
//       }

//       setFormPregunta(prev => ({

//         ...prev,

//         opciones:
//           prev.opciones.filter(
//             (_, i) => i !== index
//           )
//       }));
//     };

//   /* =====================================================
//      IMAGEN
//   ===================================================== */

//   const handleImagen =
//     (e) => {

//       const file =
//         e.target.files[0];

//       if (!file) return;

//       setFormPregunta(prev => ({
//         ...prev,
//         imagen: file
//       }));

//       setImagenPreview(
//         URL.createObjectURL(file)
//       );
//     };

//   /* =====================================================
//      GUARDAR PREGUNTA
//   ===================================================== */

//   const guardarPregunta =
//     async () => {

//       try {

//         if (
//           !formPregunta.enunciado
//             .trim()
//         ) {

//           return alert(
//             "Ingrese el enunciado"
//           );
//         }

//         const opcionesValidas =
//           formPregunta.opciones.filter(
//             o => o.texto.trim()
//           );

//         if (
//           opcionesValidas.length < 2
//         ) {

//           return alert(
//             "Debe agregar mínimo 2 opciones"
//           );
//         }

//         const correcta =
//           opcionesValidas.find(
//             o => o.es_correcta
//           );

//         if (!correcta) {

//           return alert(
//             "Seleccione una respuesta correcta"
//           );
//         }

//         setLoadingPregunta(
//           true
//         );

//         /* =========================================
//            FORMDATA
//         ========================================= */

//         const formData =
//           new FormData();

//         formData.append(
//           "simulacro_id",
//           Number(
//             formPregunta.simulacro_id
//           )
//         );

//         formData.append(
//           "materia_simulacro_id",
//           Number(
//             formPregunta
//               .materia_simulacro_id
//           )
//         );

//         formData.append(
//           "enunciado",
//           formPregunta.enunciado
//             .trim()
//         );

//         formData.append(
//           "tipo",
//           formPregunta.tipo
//         );

//         formData.append(
//           "explicacion",
//           formPregunta.explicacion
//             .trim()
//         );

//         formData.append(
//           "opciones",
//           JSON.stringify(
//             opcionesValidas
//           )
//         );

//         if (
//           formPregunta.imagen
//         ) {

//           formData.append(
//             "imagen",
//             formPregunta.imagen
//           );
//         }

//         /* =========================================
//            REQUEST
//         ========================================= */

//         await axios.post(
//           `${API}/simulacros/profesor/pregunta`,
//           formData,
//           {
//             headers: {

//               ...headers,

//               "Content-Type":
//                 "multipart/form-data"
//             }
//           }
//         );

//         /* =========================================
//            REFRESH
//         ========================================= */

//         await fetchPreguntas(
//           formPregunta.simulacro_id
//         );

//         await fetchAsignaciones();

//         /* =========================================
//            RESET
//         ========================================= */

//         setImagenPreview(
//           null
//         );

//         setFormPregunta(prev => ({

//           ...prev,

//           enunciado: "",

//           explicacion: "",

//           imagen: null,

//           opciones:
//             crearOpcionesVacias()
//         }));

//         alert(
//           "✅ Pregunta guardada"
//         );

//       } catch (err) {

//         console.error(err);

//         alert(
//           err?.response?.data?.message ||
//           "Error guardando pregunta"
//         );

//       } finally {

//         setLoadingPregunta(
//           false
//         );
//       }
//     };

//   /* =====================================================
//      ELIMINAR PREGUNTA
//   ===================================================== */

//   const eliminarPregunta =
//     async (id, simulacro_id) => {

//       try {

//         const confirmar =
//           window.confirm(
//             "¿Eliminar pregunta?"
//           );

//         if (!confirmar) return;

//         await axios.delete(
//           `${API}/simulacros/profesor/pregunta/${id}`,
//           { headers }
//         );

//         await fetchPreguntas(
//           simulacro_id
//         );

//         await fetchAsignaciones();

//       } catch (err) {

//         console.error(err);

//         alert(
//           err?.response?.data?.message ||
//           "Error eliminando pregunta"
//         );
//       }
//     };

//   /* =====================================================
//      PARSE OPCIONES
//   ===================================================== */

//   const obtenerOpciones =
//     (opciones) => {

//       if (!opciones)
//         return [];

//       if (
//         Array.isArray(opciones)
//       ) {

//         return opciones;
//       }

//       try {

//         return JSON.parse(
//           opciones
//         );

//       } catch {

//         return [];
//       }
//     };

//   /* =====================================================
//      UI
//   ===================================================== */

//   return (

//     <div className="profesor-container">

//       <h2>
//         🧠 Profesor - Simulacros
//       </h2>

//       {
//         asignaciones.length === 0 && (
//           <p>
//             No tienes asignaciones
//           </p>
//         )
//       }

//       {
//         asignaciones.map(a => (

//           <div
//             key={a.id}
//             className="simulacro-card"
//           >

//             <h3>
//               📘 {a.titulo}
//             </h3>

//             <p>
//               {a.descripcion}
//             </p>

//             <p>
//               <b>Materia:</b>{" "}
//               {a.materia}
//             </p>

//             <p>
//               <b>Sede:</b>{" "}
//               {a.sede}
//             </p>

//             <p>
//               <b>Preguntas:</b>{" "}
//               {a.total_preguntas}
//             </p>

//             <p>

//               <b>Estado:</b>{" "}

//               <span
//                 className={`estado ${a.estado}`}
//               >

//                 {
//                   a.estado ||
//                   "pendiente"
//                 }

//               </span>

//             </p>

//             <div className="card-actions">

//               <button
//                 className="btn btn-primary"
//                 onClick={() =>
//                   abrirFormulario(a)
//                 }
//               >

//                 Administrar preguntas

//               </button>

//               <button

//                 className={`btn ${
//                   a.estado ===
//                   "terminado"
//                     ? "btn-disabled"
//                     : "btn-success"
//                 }`}

//                 disabled={
//                   a.estado ===
//                   "terminado" ||

//                   loadingFinalizar ===
//                   a.id
//                 }

//                 onClick={() =>
//                   finalizarAsignacion(a)
//                 }
//               >

//                 {
//                   loadingFinalizar ===
//                   a.id
//                     ? "Finalizando..."
//                     : a.estado ===
//                       "terminado"
//                     ? "✔ Terminado"
//                     : "✔ Finalizar"
//                 }

//               </button>

//             </div>

//             {
//               mostrarFormulario ===
//               a.id && (

//                 <div className="form-pregunta">

//                   <h3>
//                     ➕ Nueva pregunta
//                   </h3>

//                   {/* =====================
//                       ENUNCIADO
//                   ===================== */}

//                   <textarea

//                     placeholder="Escriba el enunciado"

//                     value={
//                       formPregunta.enunciado
//                     }

//                     onChange={(e) =>
//                       setFormPregunta({
//                         ...formPregunta,
//                         enunciado:
//                           e.target.value
//                       })
//                     }
//                   />

//                   {/* =====================
//                       IMAGEN
//                   ===================== */}

//                   <div className="upload-box">

//                     <label>
//                       📷 Imagen pregunta
//                     </label>

//                     <input
//                       type="file"
//                       accept="image/*"
//                       onChange={
//                         handleImagen
//                       }
//                     />

//                   </div>

//                   {
//                     imagenPreview && (

//                       <div className="preview-box">

//                         <img
//                           src={
//                             imagenPreview
//                           }
//                           alt="preview"
//                           className="preview-img"
//                         />

//                       </div>
//                     )
//                   }

//                   {/* =====================
//                       EXPLICACIÓN
//                   ===================== */}

//                   <textarea

//                     placeholder="Explicación"

//                     value={
//                       formPregunta.explicacion
//                     }

//                     onChange={(e) =>
//                       setFormPregunta({
//                         ...formPregunta,
//                         explicacion:
//                           e.target.value
//                       })
//                     }
//                   />

//                   {/* =====================
//                       OPCIONES
//                   ===================== */}

//                   <h4>
//                     Opciones
//                   </h4>

//                   {
//                     formPregunta.opciones.map(
//                       (o, i) => (

//                         <div
//                           key={i}
//                           className={`opcion ${
//                             o.es_correcta
//                               ? "correcta"
//                               : ""
//                           }`}
//                         >

//                           <input
//                             type="radio"

//                             checked={
//                               o.es_correcta
//                             }

//                             onChange={() =>
//                               seleccionarCorrecta(i)
//                             }
//                           />

//                           <div className="letra">

//                             {letras[i]}

//                           </div>

//                           <input
//                             type="text"

//                             value={o.texto}

//                             onChange={(e) =>
//                               handleOpcionTexto(
//                                 i,
//                                 e.target.value
//                               )
//                             }
//                           />

//                           <button
//                             className="btn btn-danger"

//                             onClick={() =>
//                               eliminarOpcionFormulario(i)
//                             }
//                           >

//                             X

//                           </button>

//                         </div>
//                       )
//                     )
//                   }

//                   <button
//                     className="btn"

//                     onClick={
//                       agregarOpcion
//                     }
//                   >

//                     ➕ Agregar opción

//                   </button>

//                   {/* =====================
//                       GUARDAR
//                   ===================== */}

//                   <button

//                     className="btn btn-success"

//                     onClick={
//                       guardarPregunta
//                     }

//                     disabled={
//                       loadingPregunta
//                     }
//                   >

//                     {
//                       loadingPregunta
//                         ? "Guardando..."
//                         : "Guardar pregunta"
//                     }

//                   </button>

//                   {/* =====================
//                       LISTADO
//                   ===================== */}

//                   <h3>
//                     📚 Preguntas
//                   </h3>

//                   {
//                     (
//                       preguntas[
//                         a.simulacro_id
//                       ] || []
//                     ).map(p => (

//                       <div
//                         key={p.id}
//                         className="pregunta-card"
//                       >

//                         <p>
//                           <b>
//                             {p.enunciado}
//                           </b>
//                         </p>

//                         {
//                           p.imagen_url && (

//                             <img
//                               src={
//                                 p.imagen_url
//                               }

//                               alt="pregunta"

//                               className="pregunta-img"
//                             />
//                           )
//                         }

//                         {
//                           obtenerOpciones(
//                             p.opciones
//                           ).map((op, i) => (

//                             <div
//                               key={i}
//                               className="opcion-view"
//                             >

//                               {letras[i]}.{" "}

//                               {
//                                 op.texto ||
//                                 op.opcion
//                               }

//                               {
//                                 op.es_correcta &&
//                                 " ✅"
//                               }

//                             </div>
//                           ))
//                         }

//                         {
//                           p.explicacion && (

//                             <div className="explicacion-box">

//                               <b>
//                                 Explicación:
//                               </b>

//                               <p>
//                                 {
//                                   p.explicacion
//                                 }
//                               </p>

//                             </div>
//                           )
//                         }

//                         <button

//                           className="btn btn-danger"

//                           onClick={() =>
//                             eliminarPregunta(
//                               p.id,
//                               a.simulacro_id
//                             )
//                           }
//                         >

//                           🗑 Eliminar

//                         </button>

//                       </div>
//                     ))
//                   }

//                 </div>
//               )
//             }

//           </div>
//         ))
//       }

//     </div>
//   );
// }

import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import { API } from "../components/config";

import "../style/ProfesorSimulacros.css";

export default function ProfesorSimulacros() {

  const token =
    localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`
  };

  /* =====================================================
     STATES
  ===================================================== */

  const [asignaciones,
    setAsignaciones] = useState([]);

  const [preguntas,
    setPreguntas] = useState({});

  const [mostrarFormulario,
    setMostrarFormulario] = useState(null);

  const [loadingPregunta,
    setLoadingPregunta] = useState(false);

  const [loadingFinalizar,
    setLoadingFinalizar] = useState(null);

  const [imagenPreview,
    setImagenPreview] = useState(null);

  const letras = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H"
  ];

  /* =====================================================
     OPCIONES VACÍAS
  ===================================================== */

  const crearOpcionesVacias =
    () => ([
      {
        texto: "",
        es_correcta: false
      },
      {
        texto: "",
        es_correcta: false
      },
      {
        texto: "",
        es_correcta: false
      },
      {
        texto: "",
        es_correcta: false
      }
    ]);

  /* =====================================================
     FORM PREGUNTA
  ===================================================== */

  const [formPregunta,
    setFormPregunta] = useState({

      simulacro_id: "",

      materia_simulacro_id: "",

      enunciado: "",

      tipo: "opcion_multiple",

      explicacion: "",

      imagen: null,

      opciones:
        crearOpcionesVacias()
    });

  /* =====================================================
     FETCH ASIGNACIONES
  ===================================================== */

  const fetchAsignaciones =
    async () => {

      try {

        const res =
          await axios.get(
            `${API}/simulacros/profesor/asignaciones`,
            { headers }
          );

        setAsignaciones(
          res.data.asignaciones || []
        );

      } catch (err) {

        console.error(
          "❌ Error asignaciones:",
          err
        );
      }
    };

  /* =====================================================
     FETCH PREGUNTAS
  ===================================================== */

  const fetchPreguntas =
    async (simulacro_id) => {

      try {

        const res =
          await axios.get(
            `${API}/simulacros/profesor/preguntas/${simulacro_id}`,
            { headers }
          );

        setPreguntas(prev => ({

          ...prev,

          [simulacro_id]:
            res.data.preguntas || []

        }));

      } catch (err) {

        console.error(
          "❌ Error preguntas:",
          err
        );
      }
    };

  /* =====================================================
     INIT
  ===================================================== */

  useEffect(() => {

    fetchAsignaciones();

  }, []);

  /* =====================================================
     ABRIR FORM
  ===================================================== */

  const abrirFormulario =
    (a) => {

      setMostrarFormulario(a.id);

      setImagenPreview(null);

      setFormPregunta({

        simulacro_id:
          Number(a.simulacro_id),

        materia_simulacro_id:
          Number(a.materia_simulacro_id),

        enunciado: "",

        tipo: "opcion_multiple",

        explicacion: "",

        imagen: null,

        opciones:
          crearOpcionesVacias()
      });

      fetchPreguntas(
        a.simulacro_id
      );
    };

  /* =====================================================
     FINALIZAR
  ===================================================== */

  const finalizarAsignacion =
    async (a) => {

      try {

        const confirmar =
          window.confirm(
            "¿Desea finalizar esta asignación?"
          );

        if (!confirmar) return;

        setLoadingFinalizar(
          a.id
        );

        await axios.post(
          `${API}/simulacros/profesor/finalizar`,
          {

            simulacro_id:
              Number(a.simulacro_id),

            materia_simulacro_id:
              Number(a.materia_simulacro_id)

          },
          { headers }
        );

        await fetchAsignaciones();

        alert(
          "✅ Asignación finalizada"
        );

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.message ||
          "Error finalizando"
        );

      } finally {

        setLoadingFinalizar(
          null
        );
      }
    };

  /* =====================================================
     NORMALIZAR TEXTO
     🔥 AQUÍ ESTABA EL PROBLEMA
  ===================================================== */

  const limpiarTextoOpcion =
    (texto = "") => {

      return String(texto)
        .replace(/\s+/g, " ")
        .trim();
    };

  /* =====================================================
     OPCIONES
  ===================================================== */

  const handleOpcionTexto =
    (index, value) => {

      const valorLimpio =
        limpiarTextoOpcion(value);

      setFormPregunta(prev => {

        const nuevasOpciones =
          [...prev.opciones];

        nuevasOpciones[index] = {

          ...nuevasOpciones[index],

          texto: valorLimpio
        };

        return {

          ...prev,

          opciones:
            nuevasOpciones
        };
      });
    };

  const seleccionarCorrecta =
    (index) => {

      const nuevas =
        formPregunta.opciones.map(
          (o, i) => ({

            ...o,

            es_correcta:
              i === index
          })
        );

      setFormPregunta(prev => ({

        ...prev,

        opciones: nuevas
      }));
    };

  const agregarOpcion =
    () => {

      setFormPregunta(prev => ({

        ...prev,

        opciones: [

          ...prev.opciones,

          {
            texto: "",
            es_correcta: false
          }

        ]
      }));
    };

  const eliminarOpcionFormulario =
    (index) => {

      if (
        formPregunta.opciones
          .length <= 2
      ) {

        return alert(
          "Debe existir mínimo 2 opciones"
        );
      }

      setFormPregunta(prev => ({

        ...prev,

        opciones:
          prev.opciones.filter(
            (_, i) => i !== index
          )
      }));
    };

  /* =====================================================
     IMAGEN
  ===================================================== */

  const handleImagen =
    (e) => {

      const file =
        e.target.files[0];

      if (!file) return;

      setFormPregunta(prev => ({

        ...prev,

        imagen: file
      }));

      setImagenPreview(
        URL.createObjectURL(file)
      );
    };

  /* =====================================================
     GUARDAR PREGUNTA
  ===================================================== */

  const guardarPregunta =
    async () => {

      try {

        if (
          !formPregunta.enunciado
            .trim()
        ) {

          return alert(
            "Ingrese el enunciado"
          );
        }

        /* =========================================
           NORMALIZAR OPCIONES
        ========================================= */

        const opcionesNormalizadas =
          formPregunta.opciones.map(op => ({

            texto:
              limpiarTextoOpcion(
                op.texto
              ),

            es_correcta:
              Boolean(
                op.es_correcta
              )
          }));

        const opcionesValidas =
          opcionesNormalizadas.filter(
            o => o.texto !== ""
          );

        if (
          opcionesValidas.length < 2
        ) {

          return alert(
            "Debe agregar mínimo 2 opciones"
          );
        }

        const correcta =
          opcionesValidas.find(
            o => o.es_correcta
          );

        if (!correcta) {

          return alert(
            "Seleccione una respuesta correcta"
          );
        }

        setLoadingPregunta(
          true
        );

        /* =========================================
           DEBUG
        ========================================= */

        console.log(
          "🔥 OPCIONES ENVIADAS:",
          opcionesValidas
        );

        /* =========================================
           FORMDATA
        ========================================= */

        const formData =
          new FormData();

        formData.append(
          "simulacro_id",
          Number(
            formPregunta.simulacro_id
          )
        );

        formData.append(
          "materia_simulacro_id",
          Number(
            formPregunta
              .materia_simulacro_id
          )
        );

        formData.append(
          "enunciado",
          formPregunta.enunciado
            .trim()
        );

        formData.append(
          "tipo",
          formPregunta.tipo
        );

        formData.append(
          "explicacion",
          formPregunta.explicacion
            .trim()
        );

        formData.append(
          "opciones",
          JSON.stringify(
            opcionesValidas
          )
        );

        if (
          formPregunta.imagen
        ) {

          formData.append(
            "imagen",
            formPregunta.imagen
          );
        }

        /* =========================================
           REQUEST
        ========================================= */

        await axios.post(
          `${API}/simulacros/profesor/pregunta`,
          formData,
          {
            headers: {

              ...headers,

              "Content-Type":
                "multipart/form-data"
            }
          }
        );

        /* =========================================
           REFRESH
        ========================================= */

        await fetchPreguntas(
          formPregunta.simulacro_id
        );

        await fetchAsignaciones();

        /* =========================================
           RESET
        ========================================= */

        setImagenPreview(
          null
        );

        setFormPregunta(prev => ({

          ...prev,

          enunciado: "",

          explicacion: "",

          imagen: null,

          opciones:
            crearOpcionesVacias()
        }));

        alert(
          "✅ Pregunta guardada"
        );

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.message ||
          "Error guardando pregunta"
        );

      } finally {

        setLoadingPregunta(
          false
        );
      }
    };

  /* =====================================================
     ELIMINAR PREGUNTA
  ===================================================== */

  const eliminarPregunta =
    async (id, simulacro_id) => {

      try {

        const confirmar =
          window.confirm(
            "¿Eliminar pregunta?"
          );

        if (!confirmar) return;

        await axios.delete(
          `${API}/simulacros/profesor/pregunta/${id}`,
          { headers }
        );

        await fetchPreguntas(
          simulacro_id
        );

        await fetchAsignaciones();

      } catch (err) {

        console.error(err);

        alert(
          err?.response?.data?.message ||
          "Error eliminando pregunta"
        );
      }
    };

  /* =====================================================
     PARSE OPCIONES
  ===================================================== */

  const obtenerOpciones =
    (opciones) => {

      if (!opciones)
        return [];

      if (
        Array.isArray(opciones)
      ) {

        return opciones;
      }

      try {

        return JSON.parse(
          opciones
        );

      } catch {

        return [];
      }
    };

  /* =====================================================
     UI
  ===================================================== */

  return (

    <div className="profesor-container">

      <h2>
        🧠 Profesor - Simulacros
      </h2>

      {
        asignaciones.length === 0 && (
          <p>
            No tienes asignaciones
          </p>
        )
      }

      {
        asignaciones.map(a => (

          <div
            key={a.id}
            className="simulacro-card"
          >

            <h3>
              📘 {a.titulo}
            </h3>

            <p>
              {a.descripcion}
            </p>

            <p>
              <b>Materia:</b>{" "}
              {a.materia}
            </p>

            <p>
              <b>Sede:</b>{" "}
              {a.sede}
            </p>

            <p>
              <b>Preguntas:</b>{" "}
              {a.total_preguntas}
            </p>

            <p>

              <b>Estado:</b>{" "}

              <span
                className={`estado ${a.estado}`}
              >

                {
                  a.estado ||
                  "pendiente"
                }

              </span>

            </p>

            <div className="card-actions">

              <button
                className="btn btn-primary"
                onClick={() =>
                  abrirFormulario(a)
                }
              >

                Administrar preguntas

              </button>

              <button

                className={`btn ${
                  a.estado ===
                  "terminado"
                    ? "btn-disabled"
                    : "btn-success"
                }`}

                disabled={
                  a.estado ===
                  "terminado" ||

                  loadingFinalizar ===
                  a.id
                }

                onClick={() =>
                  finalizarAsignacion(a)
                }
              >

                {
                  loadingFinalizar ===
                  a.id
                    ? "Finalizando..."
                    : a.estado ===
                      "terminado"
                    ? "✔ Terminado"
                    : "✔ Finalizar"
                }

              </button>

            </div>

            {
              mostrarFormulario ===
              a.id && (

                <div className="form-pregunta">

                  <h3>
                    ➕ Nueva pregunta
                  </h3>

                  <textarea

                    placeholder="Escriba el enunciado"

                    value={
                      formPregunta.enunciado
                    }

                    onChange={(e) =>
                      setFormPregunta({
                        ...formPregunta,
                        enunciado:
                          e.target.value
                      })
                    }
                  />

                  <div className="upload-box">

                    <label>
                      📷 Imagen pregunta
                    </label>

                    <input
                      type="file"
                      accept="image/*"
                      onChange={
                        handleImagen
                      }
                    />

                  </div>

                  {
                    imagenPreview && (

                      <div className="preview-box">

                        <img
                          src={
                            imagenPreview
                          }
                          alt="preview"
                          className="preview-img"
                        />

                      </div>
                    )
                  }

                  <textarea

                    placeholder="Explicación"

                    value={
                      formPregunta.explicacion
                    }

                    onChange={(e) =>
                      setFormPregunta({
                        ...formPregunta,
                        explicacion:
                          e.target.value
                      })
                    }
                  />

                  <h4>
                    Opciones
                  </h4>

                  {
                    formPregunta.opciones.map(
                      (o, i) => (

                        <div
                          key={`op-${i}`}
                          className={`opcion ${
                            o.es_correcta
                              ? "correcta"
                              : ""
                          }`}
                        >

                          <input
                            type="radio"

                            checked={
                              o.es_correcta
                            }

                            onChange={() =>
                              seleccionarCorrecta(i)
                            }
                          />

                          <div className="letra">

                            {letras[i]}

                          </div>

                          <input
                            type="text"
                            autoComplete="off"
                            spellCheck={false}

                            value={o.texto}

                            onChange={(e) =>
                              handleOpcionTexto(
                                i,
                                e.target.value
                              )
                            }
                          />

                          <button
                            type="button"
                            className="btn btn-danger"

                            onClick={() =>
                              eliminarOpcionFormulario(i)
                            }
                          >

                            X

                          </button>

                        </div>
                      )
                    )
                  }

                  <button
                    type="button"
                    className="btn"

                    onClick={
                      agregarOpcion
                    }
                  >

                    ➕ Agregar opción

                  </button>

                  <button

                    type="button"

                    className="btn btn-success"

                    onClick={
                      guardarPregunta
                    }

                    disabled={
                      loadingPregunta
                    }
                  >

                    {
                      loadingPregunta
                        ? "Guardando..."
                        : "Guardar pregunta"
                    }

                  </button>

                  <h3>
                    📚 Preguntas
                  </h3>

                  {
                    (
                      preguntas[
                        a.simulacro_id
                      ] || []
                    ).map(p => (

                      <div
                        key={p.id}
                        className="pregunta-card"
                      >

                        <p>
                          <b>
                            {p.enunciado}
                          </b>
                        </p>

                        {
                          p.imagen_url && (

                            <img
                              src={
                                p.imagen_url
                              }

                              alt="pregunta"

                              className="pregunta-img"
                            />
                          )
                        }

                        {
                          obtenerOpciones(
                            p.opciones
                          ).map((op, i) => (

                            <div
                              key={i}
                              className="opcion-view"
                            >

                              {letras[i]}.{" "}

                              {
                                op.texto ||
                                op.opcion
                              }

                              {
                                op.es_correcta &&
                                " ✅"
                              }

                            </div>
                          ))
                        }

                        {
                          p.explicacion && (

                            <div className="explicacion-box">

                              <b>
                                Explicación:
                              </b>

                              <p>
                                {
                                  p.explicacion
                                }
                              </p>

                            </div>
                          )
                        }

                        <button

                          type="button"

                          className="btn btn-danger"

                          onClick={() =>
                            eliminarPregunta(
                              p.id,
                              a.simulacro_id
                            )
                          }
                        >

                          🗑 Eliminar

                        </button>

                      </div>
                    ))
                  }

                </div>
              )
            }

          </div>
        ))
      }

    </div>
  );
}